import { Strategy } from 'utility-ts-strategy';

export const CommentContentTypeStrategy = new Strategy({
  course: 'cat.Course',
  plan: ''
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/course_flag_dialog/strategies/course_flag_content_type_strategy.ts